import { CompartmentComponent, PlannerEcsMultiSystem, ProductType, UnserializableEntityComponent } from '@inter-ikea-storageone/range';
import { ComponentIds, HierarchyUtils, LocalTransformComponent, SelectableComponent, Vector, OutlineableComponent, SelectedComponent, ViewerObjectComponent, DisplayNameComponent } from '@inter-ikea-core/core';
import CompartmentModelComponent from '@inter-ikea-storageone/range/src/core-api/components/CompartmentModelComponent';
export class FrameCompartmentsSystem extends PlannerEcsMultiSystem {
    constructor(coreApi) {
        super(coreApi, 'FrameCompartmentsSystem', [
            ComponentIds.IN_SCENE_COMPONENT_ID,
            CompartmentModelComponent.id
        ]);
        this.removeCompartmentModel = (compartment) => {
            const model = compartment.getComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID)?.viewerObject;
            if (model) {
                model.deleteObject();
            }
            compartment.removeComponent(ComponentIds.VIEWER_OBJECT_COMPONENT_ID);
        };
        this.createCompartmentModel = (compartment) => {
            const size = compartment.getComponent(CompartmentComponent.id)
                ?.compartmentSize;
            if (!size)
                return;
            const model = this.coreApi.viewer.createBox(size.X + 10, size.Y + 10, size.Z + 50, compartment);
            model.makeClickable(() => {
                compartment.addComponent(new SelectedComponent());
            });
            model.setVisible(true);
            model.setEnabled(true);
            model.setBaseColor(1, 1, 1);
            model.setTransparency(0.01);
            compartment.addComponent(new ViewerObjectComponent(model));
        };
        this.coreApi = coreApi;
    }
    onAdd(entity, newComponent) {
        if (newComponent.typeId === ComponentIds.IN_SCENE_COMPONENT_ID &&
            this.coreApi.entities.isOneOfProductTypes(entity, [
                ProductType.BESTA_FRAME,
                ProductType.BESTA_TV_BENCH
            ])) {
            const frameSize = entity.getComponent(ComponentIds.TEMPLATE_DATA_COMPONENT_ID)?.size;
            const compartmentConnectors = entity
                .getComponent(ComponentIds.CONNECTORS_COMPONENT_ID)
                ?.connectors.filter(c => c.offers().includes('compartment'));
            if (!frameSize || !compartmentConnectors)
                return;
            const compartmentSize = new Vector(600, frameSize.Y, frameSize.Z);
            compartmentConnectors.forEach(compartmentConnector => {
                this.createCompartmentEntity(entity, compartmentConnector, compartmentSize);
            });
        }
        else if (newComponent.typeId === CompartmentModelComponent.id) {
            this.createCompartmentModel(entity);
        }
    }
    onUpdate() { }
    onRemove(entity, oldComponent) {
        if (oldComponent.typeId === CompartmentModelComponent.id) {
            this.removeCompartmentModel(entity);
        }
    }
    createCompartmentEntity(frame, connectorInFrame, size) {
        const interiorConnectorsInCompartment = connectorInFrame.tags();
        const entityManager = this.coreApi.getServices().entityManager;
        const compartment = entityManager.createEntity();
        compartment.addComponent(new SelectableComponent());
        compartment.addComponent(new OutlineableComponent());
        HierarchyUtils.setParent(compartment, frame);
        compartment.addComponent(new LocalTransformComponent(connectorInFrame.transform));
        compartment.addComponent(new CompartmentComponent(frame, size, connectorInFrame.key, interiorConnectorsInCompartment));
        compartment.addComponent(new DisplayNameComponent('Front layout compartment'));
        compartment.addComponent(new UnserializableEntityComponent());
    }
}
//# sourceMappingURL=FrameCompartmentsSystem.js.map